import { PropsWithChildren } from 'react';
import classNames from 'styles/utils/classNames';

type Props = {
  label?: string;
  isLast?: boolean;
  className?: string;
  shouldPreventTopPad?: boolean;
} & PropsWithChildren;

export default function FieldWrapper({
  label,
  isLast = false,
  children,
  className = '',
  shouldPreventTopPad,
}: Props) {
  const classes = classNames({
    'flex justify-between': true,
    'border-b border-color-border-input-lightmode pb-10': !isLast,
    'pt-10': !shouldPreventTopPad,
    [className]: true,
  });

  return (
    <div className={classes}>
      <div className="font-bod w-[20%] font-bold text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {label}
      </div>
      <div className="ml-6 w-[80%] shrink-0">{children}</div>
    </div>
  );
}
